export default "__VITE_ASSET__c457b039__"